<script setup lang="ts">
const { refreshToken } = useAuth()
const { refresh } = useApp()

const refreshAll = async () => {
	await refreshToken()
	await refresh()
}
</script>

<template>
	<ModalContent
		title="Vorstandsrolle übertragen"
		@close="refreshAll()"
	>
		<section class="ion-padding">
			<ion-img
				src="/assets/250701_vci_illustration_vorstand_wechseln.svg"
				alt="Vorstandsrolle übertragen Illustration"
			/>
			<div class="success-message">
				<ion-text>
					<h3>Sie haben die Vorstandsrolle erfolgreich übertragen.</h3>
					<p>Die von ihnen gewählte Person bekommt per E-Mail eine Nachricht.</p>
				</ion-text>
			</div>
		</section>
	</ModalContent>
</template>

<style scoped lang="scss">
.success-message {
	margin-top: 120px;
	text-align: center;

	h3 {
		font-weight: 600;
	}
}
</style>
